/**
 * SafetyCheck
 * The SafetyCheck API
 *
 * The version of the OpenAPI document: master-35d84d79-917289
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AreYouOkUpdateDto { 
    /**
     * The response to set.  Note: Can not set a response if one is already set
     */
    status: AreYouOkUpdateDtoStatus;
    /**
     * The channel from where status was set.
     */
    channel?: AreYouOkUpdateDtoChannel;
}
export enum AreYouOkUpdateDtoStatus {
    Ok = 'ok',
    NeedSupport = 'need-support'
};
export enum AreYouOkUpdateDtoChannel {
    Push = 'push',
    Sms = 'sms',
    Email = 'email',
    Voice = 'voice'
};



